(function ($) {
    $(".slider-items").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            fade: true,
            dots: false,
            arrows: true,
            arrowsPlacement: 'afterSlides',
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [{
                breakpoint: 768,
                settings: {
                    arrowsPlacement: 'beforeSlides',
                }
            }, ]
        });
    })

    $(".testimonial-slider-items").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            fade: true,
            dots: false,
            arrows: true,
            arrowsPlacement: 'afterSlides',
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true
        });
    })

    $(".cards-slider-items").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            fade: false,
            dots: false,
            arrows: true,
            arrowsPlacement: 'afterSlides',
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        infinite: false
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: 'unslick'
                }
            ]
        });
    })
    $(".news-slider-items").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            fade: false,
            dots: false,
            arrows: true,
            arrowsPlacement: 'afterSlides',
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        infinite: false
                    }
                },
                {
                    breakpoint: 1200,
                    settings: 'unslick'
                }
            ]
        });
    })

})(jQuery);